// /js/api/api_members.js
import { store } from "../store/store.js";
import { alertas } from "../ui/alerts.js";
import { ValidateEmail } from "../utils/helpers.js";
import { other_session_open_alert } from "../ui/general_members.js";
import { handleApiError } from "../utils/apiFetch.js";







export function login_members(){


    document.getElementById("div_button_login_start").style.display = "none";

    var email_login_members = document.getElementById("email_login_members").value;
    var password_login_members = document.getElementById("password_login_members").value;


    
     if (!email_login_members || !password_login_members) {
        
        alertas({
              type: "error",
              title: "Required",
              message: "Please fill in all fields.",
              buttonText: "Close"
            });
        return;
    }

    if (!ValidateEmail(email_login_members)) {

        alertas({
              type: "error",
              title: "Error Email",
              message: "Please enter a valid email address.",
              buttonText: "Close"
            });
        return;
    }



    if (password_login_members == "") {

        alertas({
              type: "error",
              title: "Error Password",
              message: "Please enter your Password.",
              buttonText: "Close"
            });
        return;
    }


    var data_ = {
        email: email_login_members,
        password: password_login_members
    };

    $.ajax({
        url: store.URL_PHP + "Dashboard_Members/login_func_members/",
        type: "POST",
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(data_),



        // ← SOLUCIÓN CRÍTICA
        xhrFields: {
            withCredentials: true
        },
        crossDomain: true,

        success: function(response){
            console.log("Respuesta login_func:", response);

            if(response.success == 1){

                if(response.user_exist){

                    if(response.if_password){

                       if(response.in_session){

                            // Sesión activa en otro dispositivo
                              currentLoginUserId = response.user_id;
                              

                               other_session_open_alert();


                       } else {
                         window.location.href = store.URL_PHP + 'Dashboard_Members/index';
                       }

                    }
                }
            }else{
                // errores
            }
        },
        error: function(xhr){

            console.log("Error AJAX login_func:", xhr.responseText);

             alertas({
              type: "error",
              title: "Error Server",
              message: xhr.responseText,
              buttonText: "Close"
            });

            document.getElementById("div_button_login_start").style.display = "block";
        }
    });
}











export function closeOtherSession() {

  if(!currentLoginUserId){


          alertas({
              type: "error",
              title: "Error User",
              message: "User Not Defined",
              buttonText: "Close"
            });
        return;

    }else{
      console.log(currentLoginUserId)
    }

    var data_ = {
        user_id: currentLoginUserId,
        user_type: "member"
    };

    $.ajax({
        url: store.URL_PHP + "Dashboard_Members/logout_func/",
        type: "POST",
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(data_),
        success: function(response){
            console.log("Respuesta logout_func:", response);
            if(response.success){

                // Redirigir al dashboard después de cerrar sesión anterior
               location.href = `${store.URL_PHP}Dashboard_Members/login`;
                



            } else {

                alertas({
                type: "error",
                title: "Error Session",
                message: "Error al cerrar la sesión anterior",
                buttonText: "Close"
              });

            }
        },
        error: function(xhr){
            console.log("Error AJAX logout_func:", xhr.responseText);
            alert('No se pudo conectar con el servidor.');
        }
    });
}










export async function view_details_memebrs(vendedor_id) {

  console.log("referencia::", vendedor_id);

  let res;

  // 🔥 ESTE TRY/CATCH ES OBLIGATORIO
  try {
    res = await fetch(
      `${store.URL_PHP}Dashboard_Members/get_details_member_key`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ key_member: vendedor_id }),
        credentials: "include"
      }
    );
  } catch (err) {
    handleApiError(err, "fetch");
    return null; // ⛔ cortar aquí
  }

  // ⬇️ a partir de aquí fetch YA fue exitoso
  let text;
  try {
    text = await res.text();
  } catch (err) {
    handleApiError(err, "read-text");
    return null;
  }

  let json;
  try {
    json = JSON.parse(text);
  } catch (err) {
    handleApiError("INVALID_JSON");
    return null;
  }

  if (json.success !== 1) {
    handleApiError(json.message);
    return null;
  }

  return json.data;
}











export function register(){

var email = document.getElementById("email").value;
var phone = document.getElementById("phone").value;
var nombre = document.getElementById("name").value;
//var conanp_folio = document.getElementById("conanp_folio").value;
var pass1 = document.getElementById("password").value;
var pass2 = document.getElementById("repeat_password").value;

var id_agencia = document.getElementById("id_agencia").value;


// validar términos
  const termsCheckbox = document.querySelector('input[type="checkbox"]');
  if (!termsCheckbox || !termsCheckbox.checked) {
    alertas({
      type: "error",
      title: "Terms required",
      message: "You must accept the Terms & Conditions and Privacy Policy."
    });
    return;
  }
  


  if(!ValidateEmail(email)){

   alertas({
      type: "error",
      title: "Error Email",
      message: "Invalid Format"
    });
   return;

 }else if(phone == ""){


   alertas({
      type: "error",
      title: "Error Phone",
      message: "Invalid Format"
    });
   return;

 }else if(nombre == ""){


    alertas({
      type: "error",
      title: "Error Name",
      message: "Invalid Format"
    });
   return;

 }else if(id_agencia == ""){


   alertas({
      type: "error",
      title: "Error Agenncy",
      message: "Name Shop or ID Guide"
    });
   return;

 }else if(pass1 == ''){

 
   alertas({
      type: "error",
      title: "Error Password",
      message: "Put Password 1"
    });
   return;
                                
}else if(pass2 == ''){

   
   alertas({
      type: "error",
      title: "Error Password",
      message: "Put Password 2"
    });
   return;
                                
}else if(pass1 != pass2){

    alertas({
      type: "error",
      title: "Error Password",
      message: "Password_1 must be the same as Password_2"
    });
   return;
                                
}



document.getElementById("button_register").style.display = "none";
document.getElementById("response_server").innerHTML = "Waiting Response...."



    var data_ = {
        nombre:nombre,
        email: email,
        tipo_registro: 1,
        phone: phone,
        password: pass1,
        conanp_folio: "--",
        id_agencia: id_agencia
    };

     $.ajax({
        url: store.URL_PHP  + "Dashboard_Members/register_members/",
        type: "POST",
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(data_),
        success: function(response){
            console.log("Respuesta register_func:", response);



            if(response.success == 1){

                    window.location.href = store.URL_PHP  + 'Dashboard_Members/index';

              }else if(response.success == 3){

                // Sesión activa en otro dispositivo

                  currentLoginUserId = response.user_id;
                    document.getElementById("response_server").innerHTML = `
                        <div style="width:95%; background-color:#fbd75e; padding:10px; border-radius:5px; color:#333; margin:auto;">
                            There is an active session on another device.<br>
                            <button onclick="closeOtherSession()" style="background-color:#efefef; margin-top:5px;">
                                Yes, open on this device
                            </button>
                        </div>
                    `;

               } else{

                  alertas({
                      type: "error",
                      title: "Error",
                      message: "Undefined"
                    });

               }    
                
            
        },
        error: function(xhr){
            console.log("Error AJAX login_func:", xhr.responseText);
                   alertas({
                      type: "error",
                      title: "Error Server",
                      message: xhr.responseText
                    });
        }
    });




    }